import {axios_} from "../../../tools/axios_";
import encrypt from "../../../tools/encrypt";

/**
 * 登录接口提取出来,便于以后统一改造
 * @param context react的this对象，这里主要是为了使用调用者的this.state
 * @returns {*} Promise
 */
export const requestLogin = function (context) {
  if (!context) return;
  return new Promise((resolve,reject) => {
    axios_({
      url: 'login',
      method: 'post',
      data: {
        "username": context.state.username.trim(),
        "password": encrypt(context.state.password.trim()),
        "tenantCode": context.state.merchant.trim(),
        "systemNo": "02",
      },
    }).then(res => resolve(res)).catch(e=>reject(e))
  });
}